import React from 'react';
import { NumberInput, DropdownSelector } from 'hyperdb-utils';

const PriceMinNightsForm = (props) => {
  return (
    <form>
      <fieldset>
        <NumberInput
          label="Min. nights"
          name="min_nights"
          value={ props.params.min_nights }
          onChange={ props.onChange.bind(null, 'min_nights') }
        />
        <NumberInput
          label="Variation (%)"
          name="value"
          value={ props.params.value }
          onChange={ props.onChange.bind(null, 'value') }
        />
      </fieldset>
    </form>
  );
};

PriceMinNightsForm.propTypes = {
  params: React.PropTypes.object,
  onChange: React.PropTypes.func,
};

export default PriceMinNightsForm;



// WEBPACK FOOTER //
// ./src/frontend/modules/daily-rental/rental-ruleset/components/RentalRulesetEditor/PriceMinNightsForm.jsx